<template>
  <form @submit.prevent="submit">
    <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 80vh; height: fit-content;">
      <header class="modal-card-head">
        <p class="modal-card-title">
          New Inventory
          <span style="font-size:1rem; text-overflow: elipsis">{{ plant.name }}</span>
        </p>
      </header>
      <section class="modal-card-body">
        <b-field grouped>
          <b-field label="Crate Type">
            <multiselect
              v-model="selectedCrates"
              :options="crateTypes"
              :multiple="true"
              :close-on-select="true"
              placeholder="Pick plant"
              :custom-label="(obj) => obj.name"
              track-by="name"
              style="min-width: 400px;"
            />
          </b-field>
          <b-field label="Date">
            <b-datepicker
              v-model="date"
              name="date"
              :first-day-of-week="1"
              :locale="'en-CA'"
              icon="calendar-alt"
              placeholder="Date"
            />
          </b-field>
        </b-field>
        <b-field v-for="selectedCrate of selectedCrates" :key="selectedCrate.name" grouped>
          <b-field :label="'Number of Clean ' + selectedCrate.name">
            <b-input v-model="cleanCrates[selectedCrate.value]" type="number" placeholder="Clean Crates" min="0" />
            <b-button @click="clearClean">
              Clear
            </b-button>
          </b-field>
          <b-field :label="'Number of Dirty ' + selectedCrate.name">
            <b-input v-model="dirtyCrates[selectedCrate.value]" type="number" placeholder="Dirty Crates" min="0" />
            <b-button @click="clearDirty">
              Clear
            </b-button>
          </b-field>
          <b-field :label="'Number to Repair ' + selectedCrate.name">
            <b-input v-model="repairCrates[selectedCrate.value]" type="number" placeholder="Repair Crates" min="0" />
            <b-button @click="clearRepair">
              Clear
            </b-button>
          </b-field>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button type="submit" class="button is-info is-fullwidth">
          {{ $t('global.submit') }}
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import TargetStock from '../../services/v3/targetStock'

export default {
  props: {
    plant: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      crateTypes: [
        { name: '1', value: '1' },
        { name: '1R', value: '1R' },
        { name: '1RB', value: '1RB' },
        { name: '5.1', value: '5.1' },
        { name: '5.2', value: '5.2' },
        { name: '5.5', value: '5.5' },
        { name: '7.1', value: '7.1' },
        { name: '7.2', value: '7.2' },
        { name: 'LIDS', value: 'LIDS' },
        { name: 'GPS Food', value: 'GPSFood' },
        { name: 'ZEON', value: 'ZEON' },
        { name: 'RHODIA', value: 'RHODIA' }
      ],
      selectedCrates: [{ name: '5.2', value: '5.2' }],
      output: [],
      date: new Date(),
      crateType: '5.2',
      dirtyCrates: [],
      cleanCrates: [],
      repairCrates: [],
      targets: [],
      types: []
    }
  },
  computed: {
  },
  mounted: async function () {
    this.targets = await TargetStock.get({ id_site: this.plant.id })
    if (this.targets && this.targets.length > 0) {
      this.types = JSON.parse(this.targets[0].types)
      this.selectedCrates = []
      if (this.types.map(x => x.name).includes('5.X')) {
        this.selectedCrates.push({ name: '5.2', value: '5.2' })
      }
      this.selectedCrates.push(...this.crateTypes.filter((x) => {
        return this.types.find(e => e.name === x.value)
      }))
    }
  },
  methods: {
    clearClean () {
      this.cleanCrates = []
    },
    clearDirty () {
      this.dirtyCrates = []
    },
    clearRepair () {
      this.repairCrates = []
    },
    async submit () {
      this.selectedCrates.forEach((crateType) => {
        if (this.dirtyCrates[crateType.value]) {
          this.output.push(
            {
              id_site: this.plant.id,
              status_crates: crateType.value + '__DIRTY',
              num_crates: this.dirtyCrates[crateType.value],
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
        if (this.cleanCrates[crateType.value]) {
          this.output.push(
            {
              id_site: this.plant.id,
              status_crates: crateType.value + '__CLEAN',
              num_crates: this.cleanCrates[crateType.value],
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
        if (this.repairCrates[crateType.value]) {
          this.output.push(
            {
              id_site: this.plant.id,
              status_crates: crateType.value + '__REPAIR',
              num_crates: this.repairCrates[crateType.value],
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
      })
      try {
        if (this.types.map(x => x.name).includes('5.X') && (this.selectedCrates.map(x => x.value).includes('5.2') && !this.selectedCrates.map(x => x.value).includes('5.5'))) {
          this.output.push(
            {
              id_site: this.plant.id,
              status_crates: '5.5__DIRTY',
              num_crates: 0,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
          this.output.push(
            {
              id_site: this.plant.id,
              status_crates: '5.5__CLEAN',
              num_crates: 0,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
          this.output.push(
            {
              id_site: this.plant.id,
              status_crates: '5.5__REPAIR',
              num_crates: 0,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        } else if (this.types.map(x => x.name).includes('5.X') && (!this.selectedCrates.map(x => x.value).includes('5.2') && this.selectedCrates.map(x => x.value).includes('5.5'))) {
          this.output.push(
            {
              id_site: this.plant.id,
              status_crates: '5.2__DIRTY',
              num_crates: 0,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
          this.output.push(
            {
              id_site: this.plant.id,
              status_crates: '5.2__CLEAN',
              num_crates: 0,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
          this.output.push(
            {
              id_site: this.plant.id,
              status_crates: '5.2__REPAIR',
              num_crates: 0,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
        this.$emit('submit', this.output)
        return
      } catch (error) {
        this.$buefy.toast.open({ type: 'is-danger', message: error.message, duration: 3000 })
      }
    }
  }
}
</script>

<style>
</style>
